
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

const DialogCustom = ({ user, open, handleClose, handleInactivate, primaryButton, secondaryButton  }: any) => {
  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>{`Você deseja inativar o usuário: ${user?.nome}?`}</DialogTitle>
      <DialogContent>
        <DialogContentText>
        Inativar o usuário irá desativar a conta e remover suas permissões.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="primary">
         {primaryButton}
        </Button>
        <Button onClick={() => handleInactivate(user?.publicId)} color="primary">
          {secondaryButton}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DialogCustom;
